<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="ql-editor" v-html="content"></div>
      </div>
      <!--<div class="wrap" v-if="$store.getters.lang == 'zh'">-->
        <!--<img src="@/assets/images/Serve22@2x.png" alt="">-->
        <!--<div class="map">-->
          <!--<img src="@/assets/images/Serve23@2x.png" class="map-l" alt="">-->
          <!--<div class="map-r">-->
            <!--<div class="item">-->
              <!--<div class="title">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve24@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>公交 >></span>-->
              <!--</div>-->
              <!--<div class="content">-->
                <!--<div class="items">-->
                  <!--兴龙东路站：<span>360 路</span><span>博罗 12 路</span><span>博罗2路</span><span>莞357路</span><span>莞359路</span>-->
                <!--</div>-->
                <!--<div class="items">-->
                  <!--石龙体育馆站：<span>74 路</span><span>330路</span><span>博罗128路</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="title">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve25@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>地铁 >></span>-->
              <!--</div>-->
              <!--<div class="content">-->
                <!--<div class="items">-->
                  <!--2号线石龙镇站，步行 680 米左右-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="title">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve26@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>自驾 >></span>-->
              <!--</div>-->
              <!--<div class="content">-->
                <!--<div class="items">-->
                  <!--小车停车入口处在中国举重博物馆西门<br/>-->
                  <!--停车时间：星期二至星期天9:00-18:00-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="btn">-->
                <!--本馆设有自动泊车，点击了解收费标准-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="wrap" v-else>-->
        <!--<img src="@/assets/images/Serve22en@2x.png" alt="">-->
        <!--<div class="map">-->
          <!--<img src="@/assets/images/Serve23@2x.png" class="map-l" alt="">-->
          <!--<div class="map-r">-->
            <!--<div class="item">-->
              <!--<div class="title">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve24@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>Bus >></span>-->
              <!--</div>-->
              <!--<div class="content" style="font-size: 18px;line-height: 34px;">-->
                <!--<div class="items" style="margin-top: 22px;">-->
                  <!--XingLong East Road Station：<span>360 Road</span><span>Borough 12 Road</span><span>Borough 2 Road</span><span>Guan 357 Road</span><span>Guan 359 Road</span>-->
                <!--</div>-->
                <!--<div class="items">-->
                  <!--ShiLong Gymnasium Station：<span>74 Road</span><span>330 Road</span><span>Borough 128 Road</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="title" style="width: 192px;">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve25@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>Subway >></span>-->
              <!--</div>-->
              <!--<div class="content" style="font-size: 18px;line-height: 34px;">-->
                <!--<div class="items" style="margin-top: 22px;">-->
                  <!--Line 2 Shilong Town Station, walk about 680 meters-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="title" style="width: 192px;">-->
                <!--<div class="radius">-->
                  <!--<img src="@/assets/images/Serve26@2x.png" alt="">-->
                <!--</div>-->
                <!--<span>Driving >></span>-->
              <!--</div>-->
              <!--<div class="content" style="font-size: 18px;line-height: 34px;">-->
                <!--<div class="items" style="margin-top: 22px;">-->
                  <!--The car parking entrance is at the west gate of China Weightlifting Museum<br/>-->
                  <!--Parking hours: Tuesday to Sunday 09:00-18:00-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<div class="btn">-->
                <!--Parking in the museum, click to see the fee-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A3",
    mixins : [mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 富文本内容
        content: ``,
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData()
    },
    methods:{
      async getData(val) {
        this.content = ''
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "交通路线",
          articleKey:'cms'
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)

        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }

  .container {
    .wrap {
      width: 1380px;
      margin: 0 auto;
      overflow: hidden;
      padding-bottom: 140px;

      > img {
        display: block;
        margin: 0 auto 80px;
      }

      .map {
        display: flex;
        background: #F5F8FA;

        .map-l {
          width: 761px;
          height: 810px;
        }

        .map-r {
          background: #F5F8FA;
          padding: 50px;
          .item {
            margin-top: 36px;

            &:nth-of-type(1) {
              margin-top: 0;
            }

            .title {
              display: flex;
              align-items: center;
              width: 165px;
              height: 46px;
              line-height: 46px;
              background: #575B70;
              border-radius: 23px;
              font-size: 24px;
              color: #FFFFFF;

              .radius {
                width: 40px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 3px;
                margin-top: 1px;
                margin-right: 14px;
              }

            }

            .content {
              font-weight: 400;
              font-size: 20px;
              color: #666666;
              line-height: 36px;

              .items {
                margin-top: 18px;

                &:nth-of-type(1) {
                  margin-top: 32px;
                }

                span {
                  background: #8A8F9E;
                  border-radius: 5px;
                  display: inline-block;
                  padding: 0 6px;
                  color: #fff;
                  margin-right: 10px;
                  margin-bottom: 14px;
                }
              }
            }

            .btn {
              height: 52px;
              line-height: 52px;
              background: #3C3E47;
              border-radius: 10px;
              font-family: Source Han Sans CN;
              font-size: 20px;
              color: #FFFFFE;
              text-align: center;
              cursor: pointer;
              width: 404px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Serve/A3/A3.vue